import { PUT_ABOUT_US_START } from '../../types';

export const put_about_us = (payload) => ({
  type: PUT_ABOUT_US_START,
  payload,
});
